<template>
  <div>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="promotion"
          :is_owner_view="false"
          :is_in_admin_view="true"
        ></PromotionHeader>
      </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Delete Promotion Reason"
      id="admin_delete_promotion_reason_section"
      v-show="progress == 1"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <CardedForm
      ref="admin_delete_promotion_reason_form_ref"
      id="admin_delete_promotion_reason_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit_name"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      submit_btn_text="Remove"
      submit_btn_color="red"
      v-show="progress == 1"
    >
      <v-alert dense text type="error">
        Please provide a <strong>strong reason</strong> why you are deleting
        this promotion
      </v-alert>
      <TextArea
        v-model="form.reason"
        :validation_rules="form_validations.reason"
        label="Genuine Reason"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>
      <span
        >To be sure, please enter here the title of the promotion, that you want
        to delete</span
      >
      <TextField
        v-model="form.promotion_name"
        :validation_rules="form_validations.promotion_name"
        label="Enter Promotion's Title "
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Promotion Concent Form "
      id="admin_delete_promotion_concet_form"
      v-show="progress == 2"
    >
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="promotion_admin_delete_form_ref"
      id="promotion_admin_delete_form"
      message="<b>Delete was succesfull</b> <br/> Promotion has been removed successfully"
      :is_loading="is_loading"
      :seed="{ promotion: [$route.params.id] }"
      @on-delete-success="on_success_delete"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
      v-show="progress == 2"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import CardedForm from "../../../components/CardedForm";
import TextArea from "../../../components/TextArea";
import TextField from "../../../components/TextField";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
export default {
  name: "AdminPromotionsDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    CardedForm,
    TextField,
    TextArea,
    DeleteConcentForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
      is_owner: false,
      errors: [],
      message: "",
      form: {
        reason: "",
        promotion_name: "",
      },
      form_validations: {
        reason: [
          Utils.validate.min_max_length(
            20,
            400,
            "Reason must be atleast 20 characters and less than 400 characters "
          ),
          Utils.validate.max_length(
            400,
            "Your reason should be less than 200 characters"
          ),
        ],
        promotion_name: [
          Utils.validate.is_required("Promotion's name is required"),
          Utils.validate.min_max_length(
            3,
            50,
            "Promotion's name should be between 3 and 50 characters "
          ),
        ],
      },
      progress: 1,
    };
  },
  methods: {
    on_auto_fill() {
      this.form.reason =
        "This promotion nolonger is operational, we have proved that this is the case beyond a dought";
      this.form.promotion_name = this.promotion.title;
      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.reason = "";
      this.form.promotion_name = "";
      this.errors = [];
      this.message = "";
      this.progress = 1;
    },
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion(
        {
          id: this.promotion_id,
          get_header_only: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //   console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          res.expiry = "";
          if (php_time_now < parseFloat(res.starts_on_timestamp)) {
            res.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.ends_on_timestamp)
          ) {
            res.expiry = "live";
          } else if (php_time_now > parseFloat(res.ends_on_timestamp)) {
            res.expiry = "expired";
          }
          this.promotion = res;
          if (
            this._user &&
            this._user != null &&
            this.promotion.business &&
            parseInt(this._user.id) == parseInt(this.promotion.business.user_id)
          ) {
            this.is_owner = true;
          }
          this.init_form();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading prmomotion details on admin promotion delete view",
            errors
          );
        }
      );
    },
    submit_name() {
      this.errors = [];
      this.message = "";
      //check that names match
      if (this.form.promotion_name.trim() !== this.promotion.title.trim()) {
        this.errors.push(
          "The name you have entered has to match the promotion's name exactly"
        );

        this.$refs.admin_delete_promotion_reason_form_ref.show_error_dialog();
        return;
      }
      this.progress = 2;
    },
    submit() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.send_delete_message(
        {
          message: this.form.reason,
          promotion_id: this.promotion_id,
          user_id: this.promotion.business.user.id,
          email: this.promotion.business.email,
          to_name: this.promotion.business.user.first_name + " " + this.promotion.business.user.last_name,
          promotion_name: this.promotion.title
        },
        (res) => {
          this.$emit("on-hide-loader");
          //go to lits of business
          this.on_hide_message();
        },
        (errors) => {
          this.on_hide_message();
          this.$emit("on-hide-loader");
          console.log("Errors sending delete promotion on admin ", errors);
        }
      );
    },
    on_hide_message() {
      this.$router.push("/admin/promotions/list");
    },
    on_success_delete() {
      this.submit();
    },
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "Delete A Promotion",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/promotions/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/promotions/list/view/" + this.promotion_id,
        },
        {
          text: "Delete",
          disabled: true,
          href: "/admin/promotions/list/view/" + this.promotion_id + "/delete",
        },
      ],
      navbar_cols: 3,
    });
    this.load_promotion();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#admin_delete_promotion_reason_section", options);
  },
};
</script>